import $ from "jquery";
import App from "../src/App";
